module.exports = __webpack_public_path__ + "static/media/7.93eef56a.jpg";